import { ChatLayout } from "../layouts/chat-layout";
import { RootLayout } from "../layouts/root-layout";
import { CONVERSATION_ROUTE, PRIVACY_ROUTE, TERMS_ROUTE } from "../lib/constants";
import { LegalDocumentPage } from "../pages/legal-document-page";
import privacyPolicy from "../content/legal/privacy-policy.md?raw";
import termsOfUse from "../content/legal/terms-of-use.md?raw";

// The two chat routes are param-only: the pathless layout above them renders the whole surface,
// so a leaf renders nothing of its own. React Router still warns on a matched leaf route without
// an element, so they share one empty element.
// The legal pages sit outside ChatLayout, so loading them never creates a session.
const chatSurface = <></>;

export const routes = [
  {
    element: <RootLayout />,
    children: [
      {
        element: <ChatLayout />,
        children: [
          { path: "/", element: chatSurface },
          { path: CONVERSATION_ROUTE, element: chatSurface },
        ],
      },
      { path: PRIVACY_ROUTE, element: <LegalDocumentPage title="Privacy Policy" markdown={privacyPolicy} /> },
      { path: TERMS_ROUTE, element: <LegalDocumentPage title="Terms of Use" markdown={termsOfUse} /> },
    ],
  },
];
